import React from 'react';
import { SectionReveal } from '../components/SectionReveal';
export function BenefitsSection() {
  return <section className="relative w-full bg-brand-mid py-20 md:py-28 overflow-hidden" data-id="element-28">
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" data-id="element-29" />

      <div className="relative z-10 max-w-4xl mx-auto px-4" data-id="element-30">
        <SectionReveal data-id="element-31">
          <p className="text-4xl mb-4 text-center" data-id="element-32">🎯</p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-white text-center mb-4 uppercase" data-id="element-33">
            No es solo ahorrar un poco.
          </h2>
          <p className="text-2xl sm:text-3xl text-brand-gold font-heading font-bold text-center mb-14" data-id="element-34">
            Es esto:
          </p>
        </SectionReveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-35">
          <SectionReveal delay={0.1} data-id="element-36">
            <div className="bg-brand-darker/80 border border-brand-gold/20 rounded-xl p-8 text-center h-full" data-id="element-37">
              <div className="w-16 h-16 bg-brand-gold/10 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-38">
                <span className="text-3xl" data-id="element-39">💰</span>
              </div>
              <p className="text-lg sm:text-xl text-white font-body font-semibold leading-relaxed" data-id="element-40">
                👉 Recuperar la inversión en el primer mes
              </p>
            </div>
          </SectionReveal>

          <SectionReveal delay={0.2} data-id="element-41">
            <div className="bg-brand-darker/80 border border-brand-gold/20 rounded-xl p-8 text-center h-full" data-id="element-42">
              <div className="w-16 h-16 bg-brand-gold/10 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-43">
                <span className="text-3xl" data-id="element-44">📈</span>
              </div>
              <p className="text-lg sm:text-xl text-white font-body font-semibold leading-relaxed" data-id="element-45">
                👉 Ahorrar miles de pesos todos los meses
              </p>
            </div>
          </SectionReveal>

          <SectionReveal delay={0.3} data-id="element-46">
            <div className="bg-brand-darker/80 border border-brand-gold/20 rounded-xl p-8 text-center h-full" data-id="element-47">
              <div className="w-16 h-16 bg-brand-gold/10 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-48">
                <span className="text-3xl" data-id="element-49">🏆</span>
              </div>
              <p className="text-lg sm:text-xl text-white font-body font-semibold leading-relaxed" data-id="element-50">
                👉 Y cientos de miles al año
              </p>
            </div>
          </SectionReveal>
        </div>
      </div>
    </section>;
}